<script>
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import lotsReportPdf from '@/views/private/miscellaneousreimbursement/components/CollaboratorTableTravelExpenseEmployeSeveral/components/lotsReportPdf.vue'
const name = 'detailsModal'

export default {
  name,
  mixins: [ActionsForm],
  components: {lotsReportPdf},

  props: {
    partId: {
      typeof: String,
      default: ''
    },
    partStartDate: {
      typeof: String,
      default: ''
    },
    partEndDate: {
      typeof: String,
      default: ''
    },
    partNumber: {
      typeof: Number,
      default: 0
    },
    collabId: {
      typeof: String,
      default: ''
    },
    totalPartValue: {
      typeof: Number,
      default: 0
    }
  },

  mounted () {
  },

  updated () { },

  data () {
    return {
      expenses: [],
      expensesReport: [],
      nomeArquivo: ''
    }
  },

  methods: {
    async  getDetilsByPartId (id) {
      loading.push()
      // ZC-91: sem EmpresaID o backend recorta por Guid.Empty e a gaveta vem vazia (task 027).
      await MiscellaneousExpensesRepository.GetExpenseDetailsByLoteId({ ID: id, Valor: 0, funcionarioID: this.collabId, EmpresaID: this.CompanySelected }, this.$refs.partDetailsTab.pagingLimit, this.$refs.partDetailsTab.pagingIndex)
        .then((Response) => {
          this.expenses = Response.data.data
          this.$refs.partDetailsTab.LoadAllByData(Response)
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onLoad () {
      this.getDetilsByPartId(this.partId)
    },
    Download (obj) {
      this.nomeArquivo = obj.nomeArquivo
      loading.push()
      MiscellaneousExpensesRepository.GetProofByDespesasViagemId(obj.id)
        .then((Response) => {
          const linkDownload = document.createElement('a')
          linkDownload.href = `data:image/png;base64,${Response.data}`
          linkDownload.download = this.nomeArquivo
          linkDownload.click()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    getDownloadPDf () {
      this.$refs.lotpdf.onLoad()
    }
  },
  computed: { }

}
</script>

<template>
    <div class="details-modal">
    <h4 class="label mb-2"><strong>Lote: {{partNumber}}</strong></h4>
    <div class="date">
                  <div class="date-container">
                    <div class="date-content" style="width:25%">
                      <h5>Data Início:</h5>
                      <h6>{{partStartDate}}</h6>
                    </div>
                    <div class="date-content" style="width:75%">
                      <h5>Data Encerramento:</h5>
                      <h6>{{partEndDate}}</h6>
                    </div>
                  </div>
                  <div>
                    <div class="button-container-download" v-b-tooltip.hover title="Download Relatório" @click="getDownloadPDf">
                      <button type="button" class="button-back" ><i style="font-size:16px;padding-top:2px" class="fa fa-download "></i></button>
                    </div>
                  </div>
              </div>
    <Tables ref="partDetailsTab"
                  :columns="['Categoria','Quantidade','Data da Despesa','Valor', '']"
                  :showSearch="false"
                  :showPrint="false"
                  :showDownload="false"
                  :showFullscreen="false"
                  v-on:Load="onLoad"
                  :key="0"
                >
                  <tr v-for="(expense,index) in expenses" :key="index" >
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="expense.subCategoria ? expense.subCategoria : 'N/D'"
                    />
                    <TableColumn
                    :IsText="true"
                    :status="1"
                    :value="expense.quantidade"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="expense.dataRegistroDespesa"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="formatMoney(expense.valor)"
                    />
                    <TableColumn
                      :IsLotDetail="true"
                      :HasDownloadUnico="true"
                      @Download="Download(expense)"
                      :status="1"
                    />
                  </tr>
        </Tables>
         <div class="total-container">
            <h4 class="label-total mb-2"><strong>Total: {{formatMoney(totalPartValue)}}</strong></h4>
         </div>
         <lotsReportPdf ref="lotpdf" :partId="partId" :collabId="collabId"></lotsReportPdf>
    </div>
</template>

<style scoped>
.date{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
}
.date-container{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.details-modal{
  padding:1.2rem;
}
.label-total{
  padding: 0 1.2rem 0 1.2rem;
}
.total-container{
  display: flex;
  width: 100%;
  height: 100%;
  align-content: center;
  justify-content: flex-end;
}
.button-container-download{
  display: flex;
  align-items: center;
  width: 3rem;
}
.button-back{
  width: 4rem;
  border-radius: 5px;
  background-color: #008148;
  color: #fff;
  border: 0;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/CollaboratorTableTravelExpenseEmployeSeveral/components/detailsModal.vue